import React from 'react';

import { Link } from 'react-router-dom';

import { Typography,Card, CardContent, CardMedia } from '@mui/material';


import { CheckCircle } from '@mui/icons-material';

import { demoThumbnailUrl, demoVideoUrl, demoVideoTitle, demoChannelUrl, demoChannelTitle } from '../utils/constants';

// const VideoCard = ({ video }) => {
    // console.log(video);

    const VideoCard = ({ video: { id: {
        videoId }, snippet } }) => {
        console.log(videoId ,snippet );

        const MediaCard = 
            {
                src: snippet.thumbnails.medium.url,
                title: snippet.title,
                channelTitle: snippet.channelTitle
            }
        

  return (
    <Card sx={{ width: { md: '400px', xs: '100%', background: '#1e1e1e' }, borderRadius: 0, boxShadow: 'none' }}>
        <Link to={videoId ? `/video/${videoId}` : demoVideoUrl}>
            <CardMedia>
                <img style={{ width: '400px', height: '250px' }} src={MediaCard.src} alt={MediaCard.title}/>
            </CardMedia>
            <CardContent sx={{ backgroundColor: '#1e1e1e', height: '56px' }}>
                <Link to={videoId ? `/video/${videoId}` : demoVideoUrl}>
                    <Typography variant='subtitle1' fontWeight='bold' color='#fff'>
                        {MediaCard.title.slice(0, 30) || demoVideoTitle.slice(0, 30) }
                    </Typography>
                </Link>
                <Link to={snippet.channelId ? `/channel/${snippet.channelId}` : demoChannelUrl}>
                    <Typography variant='subtitle1' fontWeight='bold' color='gray' display='flex' alignItems='center'>
                        {MediaCard.channelTitle.slice(0, 30) || demoChannelTitle.slice(0, 30)}
                        <CheckCircle sx={{ fontSize: 12, ml: '5px', color: 'gray' }} />
                    </Typography>
                </Link>
            </CardContent>
        </Link>
       
    </Card>
  )
}

export default VideoCard;